import React from 'react'
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
    Font
} from '@react-pdf/renderer'

import logo from '../../../../../_websoft/assets/images/logo.jpg'
import ceznak from '../../../../../_websoft/assets/images/ceznak.png'

import {dopTranslations} from '../config/helpers'

import {
    KARAKTERISTIKE_14509,
    KARAKTERISTIKE_13165
} from '../config/dopConfig'

Font.register({
    family: 'Roboto',
    src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
})

const styles = StyleSheet.create({

    page: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingHorizontal: 20,
        fontSize: 8.2,
        fontFamily: 'Roboto',
        color: '#222',
        lineHeight: 1.3,
        backgroundColor: '#ffffff'
    },

    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottomWidth: 1,
        borderBottomColor: '#d7d7d7',
        paddingBottom: 8,
        marginBottom: 8
    },

    headerLeft: {
        flex: 1,
        paddingRight: 14
    },

    title: {
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 0.4,
        color: '#111'
    },
    subtitle: {
        marginTop: 5,
        fontSize: 9,
        fontWeight: 'bold',
        color: '#444',
        letterSpacing: 0.6,
        textTransform: 'uppercase'
    },
    badgeContainer: {
        flexDirection: 'row',
        marginTop: 8
    },

    badge: {
        borderWidth: 1,
        borderColor: '#d9d9d9',
        backgroundColor: '#f7f7f7',
        paddingVertical: 2,
        paddingHorizontal: 7,
        marginRight: 6,
        fontSize: 7,
        color: '#444'
    },

    headerRight: {
        alignItems: 'flex-end'
    },

    ceImage: {
        width: 42
    },

    logo: {
        width: 110,
        marginTop: 6
    },

    sectionWrapper: {
        borderWidth: 1,
        borderColor: '#dcdcdc',
        marginBottom: 8
    },

    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#ececec',
    },

    lastRow: {
        borderBottomWidth: 0
    },

    leftCell: {
        width: '33%',
        backgroundColor: '#f7f7f7',
        borderRightWidth: 1,
        borderRightColor: '#ececec',
        paddingHorizontal: 6,
        paddingVertical: 4,
        justifyContent: 'center',
    },

    rightCell: {
        flex: 1,
        paddingHorizontal: 6,
        paddingVertical: 4,
        justifyContent: 'center',
    },

    label: {
        fontSize: 8,
        fontWeight: 'bold',
        color: '#333',
        lineHeight: 1.25
    },

    value: {
        fontSize: 8,
        color: '#111',
        lineHeight: 1.3
    },

    characteristicsTable: {
        borderWidth: 1,
        borderColor: '#dcdcdc',
        marginBottom: 8
    },

    characteristicsHeader: {
        flexDirection: 'row',
        backgroundColor: '#f1f1f1',
        borderBottomWidth: 1,
        borderBottomColor: '#dcdcdc',
        alignItems: 'center'
    },

    characteristicsHeaderText: {
        fontSize: 7.8,
        fontWeight: 'bold',
        color: '#222'
    },

    characteristicsRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#efefef',
    },

    characteristicsCell1: {
        width: '48%',
        borderRightWidth: 1,
        borderRightColor: '#efefef',
        paddingHorizontal: 6,
        paddingVertical: 5,
        justifyContent: 'center'
    },

    characteristicsCell2: {
        width: '17%',
        borderRightWidth: 1,
        borderRightColor: '#efefef',
        paddingHorizontal: 6,
        paddingVertical: 5,
        justifyContent: 'center'
    },

    characteristicsCell3: {
        width: '35%',
        paddingHorizontal: 6,
        paddingVertical: 5,
        justifyContent: 'center'
    },

    characteristicText: {
        fontSize: 7.6,
        lineHeight: 1.25,
        color: '#222'
    },

    groupHeader: {
        backgroundColor: '#f5f5f5',
        borderTopWidth: 1,
        borderTopColor: '#d9d9d9',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e5e5',
        paddingVertical: 5,
        paddingHorizontal: 7
    },

    groupHeaderText: {
        fontSize: 7.8,
        fontWeight: 'bold',
        color: '#222',
        letterSpacing: 0.2
    },

    footer: {
        marginTop: 8,
        borderTopWidth: 1,
        borderTopColor: '#dcdcdc',
        paddingTop: 8
    },

    declarationBox: {
        borderLeftWidth: 3,
        borderLeftColor: '#777',
        paddingLeft: 10,
        paddingVertical: 5,
        backgroundColor: '#fafafa'
    },

    footerText: {
        fontSize: 8,
        color: '#444',
        lineHeight: 1.45
    },

    signatureWrapper: {
        marginTop: 18,
        alignItems: 'flex-end'
    },

    signatureBlock: {
        width: 180,
        borderTopWidth: 1,
        borderTopColor: '#bdbdbd',
        paddingTop: 8
    },

    signatureName: {
        marginTop: 4,
        fontSize: 8.2,
        fontWeight: 'bold',
        color: '#111'
    }
})

const DopWizardPdfDocument = ({
                                  dop,
                                  selectedDebljina,
                                  lang = 'bs',
                                  debljinaLimaGore,
                                  debljinaLimaDole,
                                  sifraArtikla
                              }: any) => {

    const is14509 =
        dop?.standard === 'EN_14509_2014'

    const is13165 =
        dop?.standard === 'EN_13165_2017'

    const t = (key: string) =>
        dopTranslations?.[lang]?.[key] ||
        dopTranslations?.bs?.[key] ||
        key

    const karakteristikeRows =
        is13165
            ? KARAKTERISTIKE_13165
            : KARAKTERISTIKE_14509

    const getValue = (key: string) => {

        return (
            dop?.karakteristike?.[
                String(selectedDebljina)
                ]?.[
                key
                ]?.value || '-'
        )
    }
    const vrstaProizvoda = dop?.zaglavlje?.vrstaProizvoda || '';

    let applicationValue = t('application_14509.wall');

    if (vrstaProizvoda === 'KP') {
        applicationValue = t('application_14509.roof');
    } else if (vrstaProizvoda.startsWith('FPP')) {
        applicationValue = t('application_14509.coldroom');
    }
    const infoRows = [

        {
            label: t('product_identification'),
            value: 'Topterm ' + dop?.zaglavlje?.vrstaProizvoda
        },

/*
        {
            label: t('product_type'),
            value: dop?.zaglavlje?.vrstaProizvoda
        },

        {
            label: t('core_type'),
            value: dop?.zaglavlje?.vrstaIspune
        },*/

        {
            label: t('application'),

            value:
                dop?.standard === 'EN_13165_2017'
                    ? t('application_13165')
                    : dop?.zaglavlje?.vrstaProizvoda === 'KP'
                        ? t('application_14509_roof')
                        : dop?.zaglavlje?.vrstaProizvoda?.startsWith('FPP')
                            ? t('application_14509_coldroom')
                            : t('application_14509_wall')
        },
        {
            label: t('manufacturer'),
            value: dop?.zaglavlje?.proizvodjac
        },
        {
            label: t('system'),
            value: dop?.zaglavlje?.sistem
        },

        {
            label: t('harmonized_standard'),
            value: dop?.zaglavlje?.uskladjeniStandard
        },

        {
            label: t('notified_body'),
            value: dop?.zaglavlje?.notifiedBody
        },

        {
            label: t('technical_document'),
            value: dop?.zaglavlje?.dokument
        },
        {
            label: t('core_type'),
            value: dop?.zaglavlje?.vrstaIspune
        }

    ]

    return (

        <Document>

            <Page
                size='A4'
                style={styles.page}
            >

                {/* HEADER */}

                <View style={styles.header}>

                    <View style={styles.headerLeft}>

                        <Text style={styles.title}>
                            {t('declaration')}
                        </Text>

                        <Text style={styles.subtitle}>
                            {dop?.id + '-CPR-' + sifraArtikla}
                        </Text>

                    </View>

                    <View style={styles.headerRight}>

                        <Image
                            src={ceznak}
                            style={styles.ceImage}
                        />

                        <Image
                            src={logo}
                            style={styles.logo}
                        />

                    </View>

                </View>

                {/* MAIN INFO */}

                <View style={styles.sectionWrapper}>

                    {
                        infoRows.map((row, index) => (

                            <View
                                key={index}
                                style={[
                                    styles.row,
                                    index === infoRows.length - 1
                                        ? styles.lastRow
                                        : {}
                                ]}
                            >

                                <View style={styles.leftCell}>

                                    <Text style={styles.label}>
                                        {row.label}
                                    </Text>

                                </View>

                                <View style={styles.rightCell}>

                                    <Text style={styles.value}>
                                        {row.value || '-'}
                                    </Text>

                                </View>

                            </View>

                        ))
                    }

                    {/* 14509 ONLY */}

                    /* ===================================== */
                    /* EN 14509 */
                    /* ===================================== */

                    {
                        is14509 && (
                            <>
                                {/* REAKCIJA NA VATRU */}

                                <View style={styles.row}>

                                    <View style={styles.leftCell}>

                                        <Text style={styles.label}>
                                            {t('fire_reaction')}
                                        </Text>

                                    </View>

                                    <View style={styles.rightCell}>

                                        <Text style={styles.value}>

                                            {dop?.reakcijaNaVatru?.performance}
                                            -
                                            {dop?.reakcijaNaVatru?.smoke}
                                            ,
                                            {dop?.reakcijaNaVatru?.droplets}

                                        </Text>

                                    </View>

                                </View>

                                {/* OTPORNOST NA VATRU */}

                                <View style={styles.row}>

                                    <View style={styles.leftCell}>

                                        <Text style={styles.label}>
                                            {t('fire_resistance')}
                                        </Text>

                                    </View>

                                    <View style={styles.rightCell}>

                                        <Text style={styles.value}>

                                            {
                                                dop?.otpornostNaVatru?.enabled === 'Da'
                                                    ? `${dop?.otpornostNaVatru?.minutes || ''} `
                                                    : 'NPD'
                                            }

                                        </Text>

                                    </View>

                                </View>
                            </>
                        )
                    }

                    /* ===================================== */
                    /* EN 13165 */
                    /* ===================================== */

                    {
                        is13165 && (
                            <>
                                {/* IZOLACIJA */}

                                <View style={styles.row}>

                                    <View style={styles.leftCell}>

                                        <Text style={styles.label}>
                                            {t('core_type')}
                                        </Text>

                                    </View>

                                    <View style={styles.rightCell}>

                                        <Text style={styles.value}>
                                            {dop?.izolacija || '-'}
                                        </Text>

                                    </View>

                                </View>

                                {/* REAKCIJA NA VATRU */}

                                <View style={styles.row}>

                                    <View style={styles.leftCell}>

                                        <Text style={styles.label}>
                                            {t('fire_reaction')}
                                        </Text>

                                    </View>

                                    <View style={styles.rightCell}>

                                        <Text style={styles.value}>

                                            {
                                                `${getValue('performance')} - ${getValue('smoke')}, ${getValue('droplets')}`
                                            }

                                        </Text>

                                    </View>

                                </View>

                                {/* OTPORNOST NA VATRU */}

                                <View style={styles.row}>

                                    <View style={styles.leftCell}>

                                        <Text style={styles.label}>
                                            {t('fire_resistance')}
                                        </Text>

                                    </View>

                                    <View style={styles.rightCell}>

                                        <Text style={styles.value}>
                                            NPD
                                        </Text>

                                    </View>

                                </View>

                            </>
                        )
                    }

                    {/* MATERIAL */}

                    <View style={[styles.row, styles.lastRow]}>

                        <View style={styles.leftCell}>

                            <Text style={styles.label}>
                                {t('face_back_material')}
                            </Text>

                        </View>

                        <View style={styles.rightCell}>

                            <Text style={styles.value}>

                                {
                                    is13165
                                        ? t(dop?.materijal13165 || 'laminirana_folija')
                                        : `${dop?.materijal?.liceKvalitet || '-'} (${debljinaLimaGore || ''}) /  ${dop?.materijal?.nalicjeKvalitet || '-'}(${debljinaLimaDole})`

                                }

                            </Text>

                        </View>

                    </View>

                </View>

                {/* CHARACTERISTICS */}

                <View style={styles.characteristicsTable}>

                    <View style={styles.characteristicsHeader}>

                        <View style={styles.characteristicsCell1}>

                            <Text style={styles.characteristicsHeaderText}>
                                {t('characteristic')}
                            </Text>

                        </View>

                        <View style={styles.characteristicsCell2}>

                            <Text style={styles.characteristicsHeaderText}>
                                {t('value')}
                            </Text>

                        </View>

                        <View style={styles.characteristicsCell3}>

                            <Text style={styles.characteristicsHeaderText}>
                                {t('standard')}
                            </Text>

                        </View>

                    </View>

                    {
                        karakteristikeRows.map((item: any, index: number) => {

                            if (item.isGroup) {

                                return (

                                    <View
                                        key={`group-${index}`}
                                        style={styles.groupHeader}
                                    >

                                        <Text
                                            style={styles.groupHeaderText}
                                        >
                                            {t(item.translationKey)}
                                        </Text>

                                    </View>

                                )
                            }

                            return (

                                <View
                                    key={item.key}
                                    style={[
                                        styles.characteristicsRow,

                                        index === karakteristikeRows.length - 1
                                            ? {borderBottomWidth: 0}
                                            : {}
                                    ]}
                                >

                                    <View style={styles.characteristicsCell1}>

                                        <Text style={styles.characteristicText}>
                                            {t(item.translationKey)}
                                        </Text>

                                    </View>

                                    <View style={styles.characteristicsCell2}>

                                        <Text style={styles.characteristicText}>
                                            {getValue(item.key)}
                                        </Text>

                                    </View>

                                    <View style={styles.characteristicsCell3}>

                                        <Text style={styles.characteristicText}>

                                            {
                                                dop?.karakteristike?.[
                                                    String(selectedDebljina)
                                                    ]?.[
                                                    item.key
                                                    ]?.standard || 'NPD'
                                            }

                                        </Text>

                                    </View>

                                </View>

                            )

                        })
                    }

                </View>

                {/* FOOTER */}

                <View style={styles.footer}>

                    <View style={styles.declarationBox}>

                        <Text style={styles.footerText}>
                            {t('footer_declaration')}
                        </Text>

                        <Text
                            style={[
                                styles.footerText,
                                {
                                    marginTop: 4,
                                    color: '#666'
                                }
                            ]}
                        >
                            NPD = {t('npd_translation')}
                        </Text>

                    </View>

                    <View style={styles.signatureWrapper}>

                        <View style={styles.signatureBlock}>

                            <Text
                                style={{
                                    fontSize: 7.2,
                                    marginBottom: 8,
                                    color: '#666'
                                }}
                            >
                                {t('signed_for')}
                            </Text>

                            <Text style={styles.signatureName}>
                                Salih Lemeš
                            </Text>

                            <Text
                                style={{
                                    fontSize: 7.4,
                                    marginTop: 2,
                                    color: '#444'
                                }}
                            >
                                {t('general_manager')}
                            </Text>

                            <Text
                                style={{
                                    fontSize: 7,
                                    marginTop: 6,
                                    color: '#777'
                                }}
                            >
                                Sarajevo, BiH
                            </Text>

                        </View>

                    </View>

                </View>

            </Page>

        </Document>

    )
}

export default DopWizardPdfDocument